import React from "react";
import { Search } from "@/components";

const Hero: React.FC = () => {
  return (
    <div className="mb-4 md:mb-8">
      <section className="relative ">
        <div className="h-[500px] md:h-[600px] overflow-hidden">
          {/* <img
            src=""
            // alt="Hairstylist working on client's curly hair in salon"
            className="w-full h-full object-cover object-center"
          /> */}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
          <div className="container mx-auto max-w-6xl px-4 h-full flex flex-col justify-end pb-32">
            <div className="max-w-2xl">
              <div className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 animate-fade-in space-y-1">
                <div className="bg-gradient-to-r from-[#e2a59c] via-[#ffffff] to-[#f5e1c9] inline-block text-transparent bg-clip-text">
                  Focus On Clients.
                </div>
                <div className="bg-gradient-to-r from-[#e2a59c] via-[#ffffff] to-[#f5e1c9] inline-block text-transparent bg-clip-text">
                  Not Inventory.
                </div>
              </div>
              {/* <p className="text-white/90 text-lg md:text-xl mb-8 animate-fade-in">
                Palette saves salon owners 15+ hours per month by helping them
                order and manage inventory better.
              </p> */}
            </div>
          </div>
        </div>
      </section>
      <Search />
    </div>
  );
};

export default Hero;
